// src/graphql/common_additions.js
import { gql } from "@apollo/client";

/**
 * Common Fund Additions Query
 * 
 * Changed from quantity-based to % change based.
 * Sorted by weighted score (avg % change * total value).
 */
const COMMON_ADDITIONS = gql`
  query GetCommonFundAdditions(
    $holdingMonth: String!
    $holdingYear: String!
    $category: String
    $limit: Int = 25
  ) {
    getCommonFundAdditions(
      holdingMonth: $holdingMonth
      holdingYear: $holdingYear
      category: $category
      limit: $limit
    ) {
      stockName
      stockSector
      totalPercentChange
      totalValueInMn
      avgPercentChange
      weightedScore
      fundCount
      funds {
        mutualFundId
        mutualFundName
        percentChange
        valueInMn
      }
    }
  }
`;

export default COMMON_ADDITIONS;
